import { useDemoMode } from '@/lib/demo-mode-store';
import { FlaskConical, X } from 'lucide-react';

/**
 * DemoModeBanner — a persistent, unmistakable strip across the top
 * of the app when demo mode is on. Magenta/amber stripe so nobody
 * can confuse a demo session for production use. Click the X to
 * exit demo mode (state also toggleable via the header button).
 */
export function DemoModeBanner() {
  const { enabled, setEnabled } = useDemoMode();
  if (!enabled) return null;
  return (
    <div
      className="sticky top-0 z-30 flex items-center justify-center gap-2 px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-black shadow-md"
      style={{
        background:
          'repeating-linear-gradient(135deg, #f59e0b 0 16px, #fcd34d 16px 32px)',
      }}
      role="status"
      aria-live="polite"
    >
      <FlaskConical size={13} />
      <span>Demo / Training Mode — validation relaxed · not for clinical use</span>
      <button
        onClick={() => setEnabled(false)}
        className="ml-2 flex h-5 w-5 items-center justify-center border border-black/60 hover:bg-black/20"
        aria-label="Exit demo mode"
        title="Exit demo mode"
      >
        <X size={10} />
      </button>
    </div>
  );
}
